import { AttachmentImage } from '@/components/view/AttachmentImage';
import { Grid } from '@mui/material';
import { PhotoStatusItemDTO } from '@/types/photostatus/PhotoStatusItemDTO';
import React, { FC, ReactElement } from 'react';

interface Props {
  photos: PhotoStatusItemDTO[];
  onPhotoClick: (photo: PhotoStatusItemDTO) => void;
}

/**
 * The tiles of one verdict group, each opening full screen on click. The tiles draw the stored
 * previews — the full-size bytes are fetched only for the photo the viewer actually opens.
 * <p>
 * A tile carries no caption: the verdict is on the heading above the group and the number is on the
 * full-screen view, so repeating either on every tile would only crowd it. The number stays in the
 * alternative text, which is what names the tile for a screen reader.
 */
export const PhotoStatusPhotoList: FC<Props> = (props: Props): ReactElement => {
  const { photos, onPhotoClick } = props;

  return (
    <Grid container={true} direction={'row'} spacing={2}>
      {photos.map(
        (photo: PhotoStatusItemDTO): ReactElement => (
          <Grid item={true} key={photo.id}>
            <AttachmentImage
              content={photo.thumbnail}
              altText={`№ ${photo.photoNumber}`}
              onClick={(): void => onPhotoClick(photo)}
            />
          </Grid>
        ),
      )}
    </Grid>
  );
};
